export default "__VITE_ASSET__CXzgDoKk__"